module.exports = __webpack_public_path__ + "img/logo.4d2fad20.png";